<mat-card class="height-100">
  <mat-card-header>
    <mat-card-title
      >Adicionar grupo {{ data.is_parent ? 'pai' : '' }}</mat-card-title
    >
  </mat-card-header>
  <mat-card-content>
    <div class="flex-column mt-2 col-md-12">
      <mat-form-field id="field-codigo" class="width-100" appearance="outline">
        <mat-label>
          Nome
        </mat-label>
        <input
          matInput
          type="text"
          [formControl]="form.get('nome')"
          autocomplete="off"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('nome').touched && form.get('nome').hasError('required')
        "
      >
        {{ displayMessages.nome.required }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('nome').touched && form.get('nome').hasError('maxlength')
        "
      >
        {{ displayMessages.nome.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('nome').touched && form.get('nome').hasError('isEmptyValue')
        "
      >
        {{ displayMessages.nome.isEmptyValue }}
      </small>
    </div>
    <div class="mt-2 col-md-12">
      <fast-autocomplete
        #input
        *ngIf="!data.is_parent"
        id="field-grupo-pai"
        placeholder="Grupo pai"
        displayField="nome"
        [control]="form.get('parent_id')"
        [searchFN]="searchFn"
        (clearSelection)="form.get('parent_id').reset()"
        [controlIsEnabled]="form.get('parent_id').enabled"
        [initDataWithEmpty]="true"
        [autoFirst]="false"
        [domain_id]="tokenService.getDomain().id"
        [messages]="displayMessages.parent_id"
        [data]="{ is_parent: true }"
        [insertType]="'grupo'"
        [value_order]="'nome'"
        [pageValue]="'0'"
        [pageSizeValue]="'10'"
      >
      </fast-autocomplete>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <div class="mt-2 col-md-12 pb-2 flex justify-content-end">
      <button
        [disabled]="loading"
        mat-stroked-button
        color="warn"
        (click)="dialogRef.close()"
      >
        Cancelar
      </button>
      <button
        [disabled]="loading || !form.valid"
        mat-raised-button
        color="primary"
        (click)="submit()"
      >
        Cadastrar
      </button>
    </div>
  </mat-card-actions>
</mat-card>
